// extracted by css-extract-rspack-plugin
export default {"highlightedOverlayInCodeLine":"CodeLine-module__highlightedOverlayInCodeLine__FMeq1","highlighterElement":"CodeLine-module__highlighterElement__nPzf1"};